module.exports = __webpack_public_path__ + "static/media/thumbnail-la-plata.bedcf151.jpg";